<template>
  <div>
    <div align="left">
      <el-button type="primary" icon="el-icon-circle-plus" @click="showDialog" >增加驾驶员/押运员</el-button>
    </div>


    <el-table
      :data="tableData"
      border
      style="width: 100%"
      max-height="100%">
      <el-table-column
        fixed
        prop="acc"
        label="账号"
        width="100">
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        width="100">
      </el-table-column>

      <el-table-column
        prop="car_id"
        label="车牌号"
        width="150">
      </el-table-column>
      <!--<el-table-column-->
      <!--prop="terminals"-->
      <!--label="可用投放设备"-->
      <!--width="220">-->
      <!--</el-table-column>-->
      <el-table-column
        prop="role"
        label="角色"
        width="180">
      </el-table-column>
      <el-table-column
        prop="loginTime"
        label="最后登陆"
        width="140">
      </el-table-column>
      <el-table-column
        prop="loginIp"
        label="最后登陆IP"
        width="130">
      </el-table-column>
      <el-table-column
        prop="address"
        label="地址"
        width="300">
      </el-table-column>


      <el-table-column
        prop="regTime"
        label="注册时间"
        width="140">
      </el-table-column>
      <el-table-column
        prop="regIp"
        label="注册IP"
        width="130">
      </el-table-column>

      <el-table-column
        prop="phone"
        label="电话"
        width="110">
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="220">
        <template slot-scope="scope">

          <el-button
            @click.native.prevent="showModifyPwd(scope.$index, tableData)"
            type="primary"
            size="mini">
            修改密码
          </el-button>
          <el-button
            @click.native.prevent="showModifyCarID(scope.$index, tableData)"
            type="danger"
            size="mini">
            修改车牌
          </el-button>
          <!--<el-button-->
            <!--@click.native.prevent="changeEnable(scope.$index, tableData)"-->
            <!--size="mini" :type="tableData[scope.$index].state&1==1?'danger':'success'" >-->
            <!--{{tableData[scope.$index].state&1==1?"停用":"启用"}}-->
          <!--</el-button>-->

        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10,20,50,100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <el-dialog title="增加驾驶员" :visible.sync="dialogFormVisible">
      <el-form :model="form" align="left">

        <!--<el-form-item label="职能" :label-width="formLabelWidth">-->
          <!--<el-select v-model="form.role" placeholder="请选择用户职能">-->
            <!--<el-option label="管理员(可登陆后台查看信息)" value="管理员"></el-option>-->
            <!--<el-option label="投放员(可登陆投放终端进行医废投放)" value="投放员"></el-option>-->
          <!--</el-select>-->
        <!--</el-form-item>-->
        <el-form-item label="账号" :label-width="formLabelWidth">
          <el-input v-model="form.acc" autocomplete="on" clearable></el-input>
        </el-form-item>
        <el-form-item label="密码" :label-width="formLabelWidth">
          <el-input v-model="form.pwd" autocomplete="off" show-password clearable></el-input>
        </el-form-item>
        <el-form-item label="重复密码" :label-width="formLabelWidth">
          <el-input v-model="form.rePwd" autocomplete="off" show-password clearable ></el-input>
        </el-form-item>
        <el-form-item label="姓名" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="联系电话" :label-width="formLabelWidth">
          <el-input v-model="form.phone" autocomplete="off" clearable></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="createUser">添 加</el-button>
      </div>
    </el-dialog>



    <el-dialog title="修改密码" :visible.sync="modifyPwdVisible">
      <el-form :model="modifyPwdForm" align="left">


        <el-form-item label="账号" :label-width="formLabelWidth">
          <el-input v-model="modifyPwdForm.acc" autocomplete="on" disabled></el-input>
        </el-form-item>
        <el-form-item label="密码" :label-width="formLabelWidth">
          <el-input v-model="modifyPwdForm.pwd" autocomplete="off" show-password clearable></el-input>
        </el-form-item>
        <el-form-item label="重复密码" :label-width="formLabelWidth">
          <el-input v-model="modifyPwdForm.rePwd" autocomplete="off" show-password clearable ></el-input>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="modifyPwdVisible = false">取 消</el-button>
        <el-button type="primary" @click="modifyPwd">提 交</el-button>
      </div>
    </el-dialog>



    <el-dialog title="修改车牌" :visible.sync="modifyCarIDVisible">
      <el-form :model="modifyCarIDForm" align="left">

        <el-form-item label="账号" :label-width="formLabelWidth">
          <el-input v-model="modifyCarIDForm.acc" autocomplete="on" disabled></el-input>
        </el-form-item>
        <el-form-item label="车牌" :label-width="formLabelWidth">
          <el-input v-model="modifyCarIDForm.car_id" autocomplete="off" clearable></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="modifyCarIDVisible = false">取 消</el-button>
        <el-button type="primary" @click="modifyCarID">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
  import coder from "./enum.js"
  export default {
    methods: {
      showDialog(e){
        this.form={
          phone:'',
          role:'',
          name:'',
          acc:'',
          pwd:'',
          rePwd:''
        };
        this.dialogFormVisible=true;
      },
      modifyCarID(){
        if (this.modifyCarIDForm.acc==""){
          this.$alert('账号为空，系统错误！', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        if (this.modifyCarIDForm.car_id==""){
          this.$alert('请输入车牌号', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        let $this=this;
        window.ws.AddFunc("S2W_ModifyCarIDRes",function (code,err) {
          if (Number(code)!==coder.OK){
            $this.$alert(err+'('+code+')', '错误', {
              confirmButtonText: '确定'
            });
          }else {
            $this.$notify({
              title: '成功',
              message: '修改车牌号成功',
              type: 'success'
            });
            $this.modifyCarIDVisible=false;
            window.ws.Call("W2S_DriverList",$this.page,$this.pageSize);
          }
        });
        window.ws.Call("W2S_ModifyCarID",this.modifyCarIDForm.acc,this.modifyCarIDForm.car_id)
      },

      modifyPwd(){
        if (this.modifyPwdForm.acc==""){
          this.$alert('账号为空，系统错误！', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        if (this.modifyPwdForm.pwd==""){
          this.$alert('请输入密码', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        if (this.modifyPwdForm.rePwd==""){
          this.$alert('请再次输入密码', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        if (this.modifyPwdForm.pwd!=this.modifyPwdForm.rePwd){
          this.$alert('两次输入的密码不一致，请重新输入！', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        let $this=this;
        window.ws.AddFunc("S2W_ModifyOtherPwdRes",function (code,err) {
          if (Number(code)!==coder.OK){
            $this.$alert(err+'('+code+')', '错误', {
              confirmButtonText: '确定'
            });
          }else {
            $this.$notify({
              title: '成功',
              message: '修改驾驶员密码成功',
              type: 'success'
            });
            $this.modifyPwdVisible=false;
          }
        });
        window.ws.Call("W2S_ModifyOtherPwd",this.modifyPwdForm.acc,this.modifyPwdForm.pwd)
      },
      createUser(){
        console.log("createUser:",this.form);
        // if (this.form.role==""){
        //   this.$alert('请选择用户职能', '错误', {
        //     confirmButtonText: '确定'
        //   });
        //   return
        // }
        this.form.role="司机"
        if (this.form.acc==""){
          this.$alert('请输入账号', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        if (this.form.pwd==""){
          this.$alert('请输入密码', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        if (this.form.rePwd==""){
          this.$alert('请再次输入密码', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        if (this.form.name==""){
          this.$alert('请输入姓名', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        if (this.form.pwd!=this.form.rePwd){
          this.$alert('两次输入的密码不一致，请重新输入！', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        if (this.form.phone==""){
          this.$alert('请输入联系电话', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        let $this=this;
        window.ws.AddFunc("S2W_CreateUserRes",function (code,err,info) {
          console.log(code,coder.OK,code==coder.OK);
          if (Number(code)!==coder.OK){
            $this.$alert(err+'('+code+')', '错误', {
              confirmButtonText: '确定'
            });
          }else {
            //console.log(code, err, info);
            $this.$notify({
              title: '成功',
              message: '添加驾驶员成功',
              type: 'success'
            });
            $this.dialogFormVisible=false;
            window.ws.Call("W2S_DriverList",this.page,this.pageSize);
          }
        });
        window.ws.Call("W2S_CreateUser",this.form.acc,this.form.pwd,this.form.name,this.form.phone,this.form.role)
      },
      showModifyCarID(index,rows){
        if (rows[index].acc===null||rows[index].acc===""){
          this.$alert('系统异常，请联系管理员！', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        this.modifyCarIDForm.acc=rows[index].acc;
        this.modifyCarIDForm.car_id=rows[index].car_id;

        this.modifyCarIDVisible=true;

      },
      showModifyPwd(index,rows){
        console.log("showModifyPwd:",index,rows);
        if (rows[index].acc===null||rows[index].acc===""){
          this.$alert('系统异常，请联系管理员！', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        this.modifyPwdForm.acc=rows[index].acc;
        this.modifyPwdForm.pwd='';
        this.modifyPwdForm.rePwd='';
        this.modifyPwdVisible=true;

      },
      changeEnable(index, rows) {
        console.log("changeEnable:",index);
        if (rows[index].state&1==1){
          rows[index].state^=1
        }else{
          rows[index].state|=1
        }
      },
      handleSizeChange(e){
        //console.log("handleSizeChange:",e);

        this.pageSize=e;
        window.ws.Call("W2S_DriverList",this.page,this.pageSize);
      },
      handleCurrentChange(e){
        this.page=e;
        window.ws.Call("W2S_DriverList",this.page,this.pageSize);
      }
    },
    mounted() {
      let $this=this;
      console.log("###Page loaded !");


      window.ws.AddFunc("S2W_DriverListRes",function (code,err,currentPage,total,list) {
        console.log("S2W_DriverListRes:",code,err,currentPage,total,list)
        if (code==coder.OK){
          $this.page=currentPage;
          $this.total=total;
          $this.tableData=list;
        }
      });
      window.ws.Call("W2S_DriverList",$this.page,$this.pageSize);
    },
    data() {
      return {
        form: {
          phone:'',
          role:'',
          acc:'',
          name:'',
          pwd:'',
          rePwd:''
        },
        modifyPwdForm:{
          acc:'',
          pwd:'',
          rePwd:'',
        },
        modifyCarIDForm:{
          acc:'',
          car_id:'',
        },
        dialogFormVisible:false,
        modifyPwdVisible:false,
        modifyCarIDVisible:false,
        formLabelWidth: '120px',
        page:1,
        pageSize:10,
        total:0,
        tableData: []
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/driverList.vue